import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { faqs } from '../../data/faqs';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-paper px-4 py-16 sm:py-24" aria-labelledby="faq-title" data-id="element-156" data-mp="2z3h2yaps1dk4">
      <div className="mx-auto max-w-3xl" data-id="element-157" data-mp="3mu4auvzp036o">
        <SectionHeading title={<span id="faq-title" data-id="element-159" data-mp="3rsfnfehdgrsl">Frequently asked questions</span>} data-id="element-158" data-mp="3mv5rdfzh9hvs" />

        <ul className="mt-10 space-y-3" data-id="element-160" data-mp="3rtqq1az2zti4">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-2xl bg-white ring-1 ring-navy-900/5" data-id="element-161" data-mp="3i1l2cdfv3y8q" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand sm:px-6 sm:py-5" data-id="element-162" data-mp="9m19hfj3shu7">
                  <span className="text-base font-extrabold leading-snug text-ink sm:text-lg" data-id="element-163" data-mp="2ah1n3sil1ubs">{f.q}</span>
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-cta text-navy-950' : 'bg-paper text-ink'}`} data-id="element-164" data-mp="25p9xplb5xun8">
                    <PlusIcon className="h-5 w-5" strokeWidth={2.5} aria-hidden="true" data-id="element-165" data-mp="2tecnjgfyatst" />
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-166" data-mp="2oe82re80fcws">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-167" data-mp="z1wgidfbzbmw">
                      <p className="px-5 pb-5 text-[15px] leading-relaxed text-muted sm:px-6" data-id="element-168" data-mp="1nsaik1jxbh3j">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <SectionCTA label="Get instant access for $27" note="One-time payment · No monthly subscription" data-id="element-169" data-mp="22pt7b3wlpuaz" />
      </div>
    </section>;
}